<script>
    import { link } from "svelte-routing";
    import { settings } from "../../stores/settingsStore";
    import Button from "../../components/Button/Button.svelte";
    import { navigate } from "svelte-routing";
</script>

<div class="min-h-600-px flex justify-center w-full">
    <div class="flex flex-col items-center select-none mb-4 h-full w-full md:w-8/12 xl:w-4/12">
        <div class="title si-font font-bold w-full text-left red-si">
            Tesseramento

            {$settings.subscriptionActiveYear}
        </div>

        <div class="my-2 w-full flex flex-col md:flex-row gap-2">
            <div class="flex items-center justify-center aspect-9-16 w-full md:w-1/2 relative outline-none focus:outline-none">
                <img src="{$settings.membershipCardFront.link}"
                    class="object-fill w-full h-full"
                    alt="{$settings.membershipCardFront.originalName}"
                />
            </div>

            <div class="flex items-center justify-center aspect-9-16 w-full md:w-1/2 relative outline-none focus:outline-none">
                <img src="{$settings.membershipCardBack.link}"
                  class="object-fill w-full h-full"
                  alt="{$settings.membershipCardBack.originalName}"
                />
            </div>
        </div>

        <div class="red-si si-font sub-title-home text-left w-full mb-6">
            LA TUA ISCRIZIONE ON-LINE
        </div>

        <div class="section-title si-font grey-content w-full">
            NUOVA ISCRIZIONE
        </div>

        <div class="w-full my-2">
            Si può effettuare la prima iscrizione a Sinistra Italiana cliccando sul bottone blu “Nuova iscrizione”. Poi procedere alla compilazione del form che si apre e alla fine effettuare il pagamento della quota di iscrizione
        </div>

        <div class="my-2 w-full flex items-start">
            <Button
                handleClick="{() => navigate('/iscriviti')}"
                content="Nuova iscrizione"
                buttonClass="w-64 bg-lb first-button cursor-pointer rounded section-title py-1"
            />
        </div>

        <div class="section-title si-font grey-content w-full">
            RINNOVO DELL’ ISCRIZIONE DI ANNI PRECEDENTI
        </div>

        <div class="w-full my-2">
            Se si è già stati iscritti/e a Sinistra Italiana, è possibile rinnovare la propria adesione cliccando sul bottone blu “Rinnovo online”. Nella pagina che si apre sarà sufficiente inserire l’indirizzo e-mail utilizzato in passato e poi cliccare sul bottone blu “Inserisci la mail”. Si riceverà quindi una e-mail contenente un link: cliccandoci si aprirà la pagina con i propri dati, dalla quale sarà possibile completare il rinnovo dell’iscrizione.
        </div>

        <div class="my-2 w-full flex items-start">
            <Button
                handleClick="{() => navigate('/iscriviti-home')}"
                content="Rinnova iscrizione"
                buttonClass="w-64 bg-lb first-button cursor-pointer rounded section-title py-1"
            />
        </div>

        <div class="w-full my-2" style="color: #666666">
            L’iscrizione richiede il pagamento di una quota minima di almeno € {$settings.minimumPaymentNotUGS.toFixed(2)}
            (nel caso di adesione ad UGS - giovani sotto i {$settings.ugsMaxAgeInclusive} anni - la quota minima è di almeno € {$settings.minimumPaymentUGS.toFixed(2)}).
        </div>

        <div class="w-full mt-12 underline">
            ATTENZIONE: l’inserimento di un indirizzo e-mail non valido o errato comporterà a te l’impossibilità ad effettuare autonomamente i rinnovi dell’iscrizione e al Partito di garantire alcuni diritti fondamentali delle/degli iscritte/i, tra cui: la ricezione di convocazioni e comunicazioni importanti, la partecipazione alle consultazioni e l’accesso ad eventuali servizi digitali riservati agli iscritti.
        </div>

        <hr class="w-full h-1 my-6">

        <div class="section-title si-font grey-content w-full">
            ISCRIVI ALTRI ONLINE
        </div>

        <div class="w-full my-2">
            <div>
                <span class="font-bold">Solo se sei già un/una iscritto/a</span> puoi cliccare su questo bottone per inserire l’iscrizione di altri che per varie ragioni sono impossibilitati a farlo.
            </div>
            <div>
                Se stai inserendo nuovi/e iscritti/e scarica qui il
                <a href="http://www.sinistraitaliana.si/public/Format_adesione.pdf" class="red-si cursor-pointer" target="_blank">MODULO</a>,
                che dovrai obbligatoriamente far firmare loro per l'accettazione delle norme sulla privacy e conservarlo in archivio.
            </div>

            <div>
                A questo punto potrai procedere con l’inserimento dei dati per gli/le iscritti/e degli anni precedenti
                o quelli raccolti nel modulo per i nuovi iscritti/e. Al click sul bottone ISCRIVI ALTRI ONLINE si aprirà
                automaticamente il form per l’inserimento dei dati.
            </div>

            <div class="w-full mt-2 mb-1 flex justify-start">
                <Button
                    handleClick="{() => navigate('/raccolta-adesioni/login')}"
                    content="Iscrivi altri online"
                    buttonClass="w-64 second-button cursor-pointer rounded section-title py-1"
                />
            </div>
        </div>

        <div class="my-4 text-lg font-bold">
            Per qualsiasi problema riscontrato durante l'iscrizione o per tutte le informazioni necessarie clicca qui
            <a
                    target="_blank"
                    use:link
                    href="/aiuto"
                    class="red-si"
            >
                clicca qui
            </a>

            per consultare le nostre FAQ.
        </div>

    </div>
</div>

<style>
    .si-font {
        font-family: "Work Sans", sans-serif !important;
    }

    @media (max-width: 1200px) {
        .title {
            font-size: 3.5rem;
        }
    }

    @media (max-width: 992px) {
        .title {
            font-size: 3.3rem;
        }
    }

    @media (max-width: 768px) {
        .title {
            font-size: 3.3rem;
        }
    }

    @media (max-width: 576px) {
        .title {
            font-size: 2.5rem;
            line-height: 3rem;
        }
    }
</style>